module.exports = __webpack_public_path__ + "static/media/Resume-1.c80c680f.png";